import useCurrentSession from './use-current-session'

const useGoogleEventUserData = () => {
  const session = useCurrentSession()
  return {
    userEmail: session.username,
    userFirstName: session.first_name,
    userLastName: session.last_name,
    userPhone: session.phone_number
  }
}

export default useGoogleEventUserData
